import { GoogleLeadsConfigAndPlaceDataOrDefault } from 'pages/googleLeads/types'
import { getProfileRequestOrigin } from 'pages/googleLeads/utils'

import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { ReduxActionType } from 'types/global'
import { authSelectors } from './auth'

export const GET_GOOGLE_LEADS_CONFIG = 'GET_GOOGLE_LEADS_CONFIG'
export const GET_GOOGLE_LEADS_CONFIG_SUCCESS = 'GET_GOOGLE_LEADS_CONFIG_SUCCESS'
export const GET_GOOGLE_LEADS_CONFIG_FAIL = 'GET_GOOGLE_LEADS_CONFIG_FAIL'
export const CLEAR_GOOGLE_LEADS_CONFIG = 'CLEAR_GOOGLE_LEADS_CONFIG'

export type GoogleLeadsConfigStoreType = {
  google_leads_config_and_place_data: GoogleLeadsConfigAndPlaceDataOrDefault
  loading: boolean
  ready: boolean
}

const initialState: GoogleLeadsConfigStoreType = {
  google_leads_config_and_place_data: {},
  loading: false,
  ready: false,
}

export default (state: GoogleLeadsConfigStoreType = initialState, action: ReduxActionType) => {
  switch (action.type) {
    case GET_GOOGLE_LEADS_CONFIG:
      return {
        ...state,
        loading: true,
        ready: false,
        orgId: action.payload.orgId,
      }
    case GET_GOOGLE_LEADS_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        google_leads_config_and_place_data: action?.payload?.google_leads_config_and_place_data,
        ready: true,
      }
    case GET_GOOGLE_LEADS_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        ready: false,
      }
    case CLEAR_GOOGLE_LEADS_CONFIG:
      return {
        ...initialState,
      }
  }
  return state
}

export function* refreshGoogleLeadsConfig(action: ReduxActionType) {
  try {
    const isLoggedInPro = yield select(authSelectors.getIsAuthenticatedPro)
    const google_leads_config_and_place_data = yield call(doGetGoogleLeadsConfig, action.payload.orgId, isLoggedInPro)
    yield put({ type: GET_GOOGLE_LEADS_CONFIG_SUCCESS, payload: { google_leads_config_and_place_data } })
  } catch (e) {
    yield put({ type: GET_GOOGLE_LEADS_CONFIG_FAIL })
  }
}

export const doGetGoogleLeadsConfig = (org_id_or_slug: string | number, isLoggedInPro: boolean) => {
  const { source, medium, campaign_id } = getProfileRequestOrigin(isLoggedInPro)

  return new Promise((resolve, reject) => {
    fetch(
      `${window.API_ROOT}/api/orgs/${org_id_or_slug}/google-profile/?source=${source}&medium=${medium}&campaign_id=${
        campaign_id || ''
      }`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch profile data.')
        }
        const data = response.json()
        resolve(data)
      })
      .catch((err) => {
        console.error('Error getting leads config data', err)
        reject(false)
      })
  })
}

export const loadGoogleLeadsConfig = (orgId) => {
  return {
    type: GET_GOOGLE_LEADS_CONFIG,
    payload: {
      orgId: orgId,
    },
  }
}

export const googleLeadsConfigSelectors = {
  getIsLoading: (state: any): boolean => !!state.googleLeadsConfig?.loading,
  getIsReady: (state: any): boolean => !!state.googleLeadsConfig?.ready,
  getGoogleLeadsConfigAndPlaceData: (state: any): GoogleLeadsConfigAndPlaceDataOrDefault =>
    state?.googleLeadsConfig?.google_leads_config_and_place_data,
  getGoogleLeadsConfigId: (state: any): number | undefined =>
    state?.googleLeadsConfig?.google_leads_config_and_place_data?.id,
}

export function* googleLeadsConfigSagas() {
  yield all([takeEvery(GET_GOOGLE_LEADS_CONFIG, refreshGoogleLeadsConfig)])
}
